import { CategoriesSideMenuWebComponent } from './component/CategoriesSideMenuWebComponent';

export { CategoriesSideMenuWebComponent };
